/**
 * Node 53:59524 (Stories list). Close to the dashboard's set but not identical:
 * the stories list has no Location column, so Versions is narrower and Name
 * takes the room.
 */
export const DOCUMENTS_TABLE_SIZE = {
  status: 102,
  versions: 76,
  readers: 88,
  activity: 104,
  createdAt: 120,
  createdBy: 152,
  location: 152,
};

/**
 * Node 53:65168 (Home 1). The dashboard table is its own size set: wider than
 * the cramped one it replaced — every cell there had been shrunk a step below
 * the Stories page — and still narrower than the full Stories list.
 */
export const DOCUMENTS_TABLE_SIZE_HOME = {
  status: 102,
  versions: 88,
  readers: 88,
  activity: 104,
  createdAt: 120,
  createdBy: 152,
  location: 152,
};

export const DOCUMENT_STATUS = {
  ACCEPTED: "Accepted",
  EXPIRED: "Expired",
  LIVE: "Live",
  ARCHIVED: "Archived",
  DRAFT: "Draft",
  DELETED: "Deleted",
  DEV: "Dev",
} as const;

export const DOCUMENT_STATUS_COLORS = {
  [DOCUMENT_STATUS.ACCEPTED]: {
    background: "#22C55E",
    text: "#F0FDF4",
  },
  [DOCUMENT_STATUS.EXPIRED]: {
    background: "#F59E0B",
    text: "#451A03",
  },
  [DOCUMENT_STATUS.LIVE]: {
    background: "#DCFCE7",
    text: "#16A34A",
  },
  [DOCUMENT_STATUS.ARCHIVED]: {
    background: "#FEF3C7",
    text: "#D97706",
  },
  [DOCUMENT_STATUS.DRAFT]: {
    background: "#F3F2F5",
    text: "#88819F",
  },
  [DOCUMENT_STATUS.DELETED]: {
    background: "#FEE2E2",
    text: "#DC2626",
  },
  [DOCUMENT_STATUS.DEV]: {
    background: "#F5F1FF",
    text: "#610CFF",
  },
};

export const HOME_DOCUMENTS_LIMIT = 10;

/**
 * The selected row's tint, and the same colour as an opaque fill.
 *
 * Anything painted OVER a selected row — the hover action panel and its
 * gradient lead-in — has to use the second one. The row's tint is 60% alpha, so
 * a panel repainting `primary-50` at full strength came out visibly more purple
 * than the row it sat on, and a panel repainting it at 60% would come out
 * darker still by compositing the tint over itself.
 *
 * #F9F7FF is primary-50 (#F5F1FF) at 60% over white, which is what the row
 * actually shows. Both live here so they cannot drift apart again.
 */
export const SELECTED_ROW_TINT = "tw-bg-primary-50/60";
export const SELECTED_ROW_TINT_SOLID = "tw-bg-[#F9F7FF]";
export const SELECTED_ROW_TINT_SOLID_FROM = "after:tw-from-[#F9F7FF]";

/**
 * How tall the list's sticky toolbar currently is, published by it as a CSS
 * variable and read by the sticky column header for its own offset.
 *
 * Measured rather than agreed: the two live in different components, and a
 * hard-coded offset drifted the moment the toolbar's padding changed — leaving a
 * band between them with rows scrolling through it. Whoever restyles the toolbar
 * next does not have to know the header exists.
 */
export const STICKY_TOOLBAR_HEIGHT_VAR = "--sd-list-toolbar-height";
/** Used until the toolbar has measured itself, i.e. for the first paint. */
export const STICKY_TOOLBAR_HEIGHT_FALLBACK = "56px";
